export default function formatBalance (amount, penny = false) {
    if (penny)
        amount = amount / 100;
    amount = parseInt(amount)
    return amount
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
